function encodeQueryData(data: { [x: string]: string | number | boolean }) {
  const ret = []
  for (const d in data) {
    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]))
  }
  return ret.join("&")
}

export function getGoogleInstallationUrl() {
  const oauth2Endpoint = "https://accounts.google.com/o/oauth2/v2/auth"
  const params = {
    client_id: `${process.env.NEXT_PUBLIC_GOOGLE_USER_AUTHZ_CLIENT_ID}`,
    redirect_uri: `${process.env.NEXT_PUBLIC_GOOGLE_USER_AUTHZ_REDIRECT_URL}`,
    response_type: "code",
    scope: [
      "https://www.googleapis.com/auth/youtube.readonly",
      "https://www.googleapis.com/auth/youtube.upload",
      "https://www.googleapis.com/auth/youtube.force-ssl",
    ].join(" "),
    include_granted_scopes: "false",
    state: "pass-through value",
    access_type: "offline",
    prompt: "consent",
  }
  const queryString = encodeQueryData(params)
  return `${oauth2Endpoint}?${queryString}`
}
